<div class="processing-status-editor" *ngIf="condition" [formGroup]="detailsFormGroup">

    <div class="row">
        <mat-form-field class="flex-grow" *ngIf="processingStatus != null && processingStatus.length > 0" appearance="fill">
            <mat-label>
              <sc-dictionary-label dictionaryKey="tmc-yard.ui.admin.filter-administration.details-editor.transport.processing-status-editor.processing-status"></sc-dictionary-label>
            </mat-label>
            <mat-select formControlName="processingStatus" name="processingStatus">
                <mat-option *ngFor="let o of processingStatus" [value]="o.key">
                  <sc-dictionary-label [dictionaryKey]="o.dictionaryKey"></sc-dictionary-label>
                </mat-option>
            </mat-select>
        </mat-form-field>
    </div>
</div>
